/**
 * The one premium table: the eight premiums the market adds to its required return, each named once. `label` is the noun the cockpit and the price explanation list ("CRE concentration");
 * `forPhrase` follows "for" in the value bridge ("your CRE concentration"). Cockpit, Results and the valuation pages all read it, so the two screens cannot name a premium differently.
 */
import type { RoundReport } from "@bsim/contracts";

export type Premia = RoundReport["scorecard"]["valuation"]["premiaBp"];
export type PremiumKey = keyof Premia;

export const PREMIA: Readonly<Record<PremiumKey, { readonly label: string; readonly forPhrase: string }>> = {
  capital: { label: "capital record", forPhrase: "your capital record" },
  creConcentration: { label: "CRE concentration", forPhrase: "your CRE concentration" },
  wholesale: { label: "wholesale funding", forPhrase: "your wholesale funding" },
  uninsured: { label: "uninsured deposits", forPhrase: "your uninsured deposits" },
  eve: { label: "rate risk", forPhrase: "your rate risk" },
  dividend: { label: "dividend cut", forPhrase: "your dividend cut" },
  enforcement: { label: "public enforcement action", forPhrase: "a public enforcement action" },
  event: { label: "a public event", forPhrase: "an event you faced" },
};

/** The premium keys in the table's order. */
export const PREMIUM_KEYS = Object.keys(PREMIA) as readonly PremiumKey[];
